/** @format */

export const enemyStates = {
  NEUTRAL: 0,
  CURRENT: 1,
  PAINSTATE: 2,
  SHOT: 3,
  MISSED: 4,
};
